import { render } from "./EquityCurveChart.vue?vue&type=template&id=1a25485a&scoped=true"
import script from "./EquityCurveChart.vue?vue&type=script&lang=js"
export * from "./EquityCurveChart.vue?vue&type=script&lang=js"

import "./EquityCurveChart.vue?vue&type=style&index=0&id=1a25485a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a25485a"]])

export default __exports__